function AddWidgetOptions({ onClick }) {
  const opts = [
    {
      name: "Text",
    },
    {
      name: "Image",
    },
    {
      name: "Multiple Choice",
    },
    {
      name: "Video",
    },
    {
      name: "Trigger",
    },
    {
      name: "Download",
    },
    {
      name: "Fill In The Blank",
    },
  ];

  return (
    <div className="WidgetOptions">
      {opts.map(({ name }, key) => {
        return (
          <div
            key={key}
            className="WidgetOption"
            onClick={() => onClick(name)}
          >
            {name}
          </div>
        )
      })}
    </div>
  )
}

export { AddWidgetOptions }